<div class="landing-coverage-page">
    <section class="banner-section">
        <div class="banner-image-container">
            <div class="banner-img">
                <picture>
                    <source srcset='assets/img/banners/landing-banner-mobile.webp' media="(max-width: 639.9px)"
                        type="image/webp">
                    <source srcset='assets/img/banners/landing-banner-mobile.png' media="(max-width: 639.9px)"
                        type="image/png">
                    <source srcset='assets/img/banners/landing-banner-tablet.webp' media="(max-width: 1024.9px)"
                        type="image/webp">
                    <source srcset='assets/img/banners/landing-banner-tablet.png' media="(max-width: 1024.9px)"
                        type="image/png">
                    <source srcset='assets/img/banners/landing-banner-desktop.webp' media="(min-width: 1025px)"
                        type="image/webp">
                    <source srcset='assets/img/banners/landing-banner-desktop.png' media="(min-width: 1025px)"
                        type="image/png">
                    <img src="assets/img/banners/landing-banner-desktop.png" alt="landing-page-banner-image">
                </picture>
            </div>
        </div>
        <div class="banner-text-content coverage-landing-section">
            <form (ngSubmit)="goToCoverage()" #formCtrl="ngForm" id="compatibilityFormDiv">
                <h1 class="header">Blazing Fast Speeds. Nationwide.</h1>
                <p class="sub-header">From coast to coast, our network has more towers in more places which means you
                    get
                    the fastest and best coverage possible.</p>
                <div class="fields-section">
                    <div class="input-section">
                        <label for="address" class="input-label space">
                            <p class="p-label">Enter your full address</p>
                            <p class="sub-label">Street Address, City, State, ZIP Code</p>
                        </label>
                        <input [(ngModel)]="address" matInput id="addressRef" type="search" list-formatter="description"
                            #addressRef="ngModel" name="addressRef" (focus)="setFoucs = true" (blur)="setFoucs = false"
                            class="geolocate" placeholder="Enter your full address" [matAutocomplete]="auto" required
                            (input)="changedAddress()" />
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addressDetails($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{ option?.description }}</mat-option>
                        </mat-autocomplete>
                        <div class="validation-background"
                            *ngIf="((!address && addressRef.touched) || (!!displayValidation && !address)) || (!displayedAddressModel && !!address)">
                            <img src="assets/icon/validation-arrow.svg" alt="validation arrow icon">
                            <label class="validation-message"
                                *ngIf="(!address && addressRef.touched) || (!!displayValidation && !address)"
                                id="required-address-msg">Full address is required</label>
                            <label class="validation-message" *ngIf="!displayedAddressModel && !!address"
                                id="invalid-address-msg">Please select address from the autocomplete list</label>
                        </div>
                    </div>
                    <div class="check-coverage-button">
                        <button class="button primary" type="submit" id="check-address-button"
                            [disabled]="!formCtrl.form.valid ||  !address || !displayedAddressModel"
                            [uiBlockButton]="processingRequest">Check coverage</button>
                    </div>
                </div>
            </form>
        </div>
    </section>
    <section class="us-map-section coverage-landing-section">
        <h2 class="title">More Towers, More Places, Great Coverage.</h2>
        <div class="us-image">
            <picture>
                <source srcset='assets/img/us-map-mobile.webp' media="(max-width: 639.9px)" type="image/webp">
                <source srcset='assets/img/us-map-mobile.png' media="(max-width: 639.9px)" type="image/png">
                <source srcset='assets/img/us-map-tablet.webp' media="(max-width: 1024.9px)" type="image/webp">
                <source srcset='assets/img/us-map-tablet.png' media="(max-width: 1024.9px)" type="image/png">
                <source srcset='assets/img/us-map-desktop.webp' media="(min-width: 1025px)" type="image/webp">
                <source srcset='assets/img/us-map-desktop.png' media="(min-width: 1025px)" type="image/png">
                <img src="assets/img/us-map-desktop.png" alt="usa-map-image">
            </picture>
        </div>
        <div class="desc">
            <p>4G LTE service requires a compatible device and compatible plan. This map displays approximate coverage.
                Actual coverage may vary. Coverage isn’t guaranteed and is subject to change without notice.</p>
        </div>
    </section>
    <section class="prepaid-phone-section coverage-landing-section">
        <div class="text-section">
            <h2 class="title">Cell Phone Plans with Coast to Coast Coverage</h2>
            <p class="desc1">FreeUP Mobile is proud to be one of very small handful of companies powered by the nation’s
                largest and most trusted GSM wireless network. As a result, FreeUP Mobile customers enjoy fast 4G LTE
                speeds and great coverage both in the city and when you are out and about exploring.</p>
            <p class="desc2">Global Wireless Solutions Best Network OneScore crowns our network partner the “Best US
                network in largest ever mobile performance evaluation.”</p>
        </div>
        <div class="image-section">
            <picture>
                <source srcset='assets/img/american-girl-with-phone-mobile.webp' media="(max-width: 639.9px)"
                    type="image/webp">
                <source srcset='assets/img/american-girl-with-phone-mobile.png' media="(max-width: 639.9px)"
                    type="image/png">
                <source srcset='assets/img/american-girl-with-phone-tablet.webp' media="(max-width: 1024.9px)"
                    type="image/webp">
                <source srcset='assets/img/american-girl-with-phone-tablet.png' media="(max-width: 1024.9px)"
                    type="image/png">
                <source srcset='assets/img/american-girl-with-phone-desktop.webp' media="(min-width: 1025px)"
                    type="image/webp">
                <source srcset='assets/img/american-girl-with-phone-desktop.png' media="(min-width: 1025px)"
                    type="image/png">
                <img src="assets/img/american-girl-with-phone-desktop.png" alt="girl-with-phone-image">
            </picture>
        </div>
    </section>
    <section class="check-phone-section coverage-landing-section">
        <h2 class="title">Bring The Phone You Already Own & Love</h2>
        <p class="description">Most phones work on our network. Let’s confirm if yours is compatible with one of the
            largest networks in the United States.</p>
        <button class="button primary" (click)="checkYourPhone()">Check your phone</button>
    </section>
    <section class="landing-faqs-section coverage-landing-section">
        <h2 class="header">FAQs to help you get started</h2>
        <div class="questions">
            <div *ngFor="let item of landingFaqs | async">
                <div *ngFor="let qst of item?.fields?.questions">
                    <app-question-answer question="{{qst?.fields?.questionText}}" [id]="qst?.fields?.questionId"
                        [class.active]="qst?.fields?.questionId == questionId"
                        [isActive]="qst?.fields?.questionId == questionId"
                        (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
                        <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
                    </app-question-answer>
                </div>
            </div>
            <div class="border"></div>
        </div>
        <div class="coverage-map-info">
            <p><b>Important Information About This Coverage Map</b><br>These maps provide a predicted high-level
                approximation of wireless coverage. There are gaps in coverage that are not shown by this high-level
                approximation. Actual coverage may differ from map graphics and may be affected by terrain, weather,
                network changes, foliage, buildings, construction, signal strength, high-usage periods, customer
                equipment, and other factors. We cannot guarantee coverage. Our coverage maps are not intended to show
                actual customer performance on the network or future network needs or build requirements inside or
                outside of existing coverage areas. Coverage maps may include areas served by unaffiliated carriers.
                Arrangements with these carriers may change from time to time, and coverage is subject to change without
                notice. Charges will be based on the location of the site receiving and transmitting the call, not the
                subscriber’s location. Your phone’s display does not indicate the rate you will be charged. These maps
                are subject to the Microsoft® Service Agreement and for informational purposes only. No guarantee is
                made regarding their completeness or accuracy. Construction projects, traffic, or other events may cause
                actual conditions to differ from these results. Map and traffic data 2013 NAVTEQ®</p>
            <p class="note">This map shows an approximation of wireless data coverage in the United States, Puerto Rico,
                and the U.S. Virgin Islands.</p>
        </div>
    </section>
</div>